import { motion } from 'framer-motion';

const backgroundStars = [
  { x: 48, y: 90, r: 1.6, delay: 0.1 },
  { x: 350, y: 60, r: 2, delay: 0.4 },
  { x: 372, y: 210, r: 1.4, delay: 0.8 },
  { x: 30, y: 250, r: 1.8, delay: 1.1 },
  { x: 120, y: 40, r: 1.3, delay: 0.6 },
  { x: 260, y: 350, r: 1.6, delay: 1.4 },
  { x: 60, y: 340, r: 1.3, delay: 0.9 },
  { x: 330, y: 330, r: 1.8, delay: 0.3 },
];

const nodes = {
  top: { x: 200, y: 70 },
  right: { x: 312, y: 292 },
  center: { x: 200, y: 226 },
  left: { x: 88, y: 292 },
};

const wingPath = `M ${nodes.top.x} ${nodes.top.y} L ${nodes.right.x} ${nodes.right.y} L ${nodes.center.x} ${nodes.center.y} L ${nodes.left.x} ${nodes.left.y} Z`;

export function ConstellationMark() {
  return (
    <svg
      viewBox="0 0 400 400"
      className="h-full w-full"
      role="img"
      aria-label="The Vela Wallet mark, rendered as a constellation chart"
    >
      <defs>
        <radialGradient id="glow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#2fb3a0" stopOpacity="0.55" />
          <stop offset="100%" stopColor="#2fb3a0" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="wing-fill" x1="200" y1="70" x2="200" y2="292" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#6fd6c4" stopOpacity="0.35" />
          <stop offset="100%" stopColor="#2fb3a0" stopOpacity="0.06" />
        </linearGradient>
      </defs>

      <motion.circle
        cx={200}
        cy={190}
        r={150}
        fill="url(#glow)"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.8, ease: 'easeOut' }}
      />

      {backgroundStars.map((s, i) => (
        <motion.circle
          key={i}
          cx={s.x}
          cy={s.y}
          r={s.r}
          fill="#f4ead1"
          initial={{ opacity: 0 }}
          animate={{ opacity: [0, 0.9, 0.4, 0.9] }}
          transition={{ duration: 3, delay: s.delay, repeat: Infinity, repeatType: 'mirror' }}
        />
      ))}

      <motion.path
        d={wingPath}
        fill="url(#wing-fill)"
        stroke="none"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.4 }}
      />

      <motion.path
        d={wingPath}
        fill="none"
        stroke="#8fe3d2"
        strokeWidth={1.25}
        strokeLinejoin="round"
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 1 }}
        transition={{ duration: 1.6, ease: 'easeInOut' }}
      />

      {Object.values(nodes).map((n, i) => (
        <motion.circle
          key={i}
          cx={n.x}
          cy={n.y}
          r={3.5}
          fill="#f4ead1"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.4 + i * 0.35 }}
        />
      ))}
    </svg>
  );
}
